/* eslint-disable */

import { arrayBufferToString } from '../utils/helpers';
import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios'

import {
  ApiBridgeCameraCreate,
  ApiBridgeCreate,
  Location,
  NotificationParams,
  NotificationActorsParams,
  ApiPaginatedCameraResponse,
  ApiPaginatedBridgeResponse,
  ApiCameraMain,
  ApiBridgeMain,
  ApiPaginatedAvailableDeviceResponse,
  ApiPaginatedSwitchResponse,
  ApiPaginatedFeedResponse,
  ApiPtzPosition,
  PaginatedLocationResponse,
  BasicLocationResponse,
  LocationGet,
  Notifications,
  NotificationActors,
  ApiAddSpeaker,
  PaginatedSpeakerResponse,
  ApiSpeakerMain,
  ApiPaginatedLayoutResponse,
  ApiLayoutCreate,
  ApiLayout,
  mediaMainRequest,
  ApiPaginatedMediaResponse,
  GetCamerasParams,
  DeleteCameraId,
  GetSpeakersParams,
  DeleteSpeakerId,
  UpdateLayoutParams,
  DeleteLayoutId,
  GetBridgeId,
  UpdateBridgeParams,
  SwapBridgeParams,
  DeleteBridgeId,
  GetFeedsParams,
  GetPTZPositionCameraId,
  MovePTZParams,
  EditLocationParams,
  DeleteLocationId,
  GetLocationId,
  GetFloorId,
  UpdateNotificationParams,
  ApiUpdateBulkCamera,
  BulkUpdateResponses,
  RecordedImageParams,
  RecordedImage,
  RecordedImageError,
  RecordedImageErrorDetails,
  PaginatedFloorsResponse,
  PaginatedFloorplansResponse,
  PaginatedEditionResponse,
  EditionsAccountId,
  EditionId,
  Edition,
  ApiPaginatedUserResponse,
  ApiAccountWithIncludes,
  ApiAccountPatch,
  GetUsersParams,
  AuditLogRequest,
  AuditEvents,
  ApiDevicePositionCamera,
  AnntRequest,
  ApiAccountCapabilities,
  FloorplanResponse,
  FloorResponse,
  TagsList,
  ApiPaginatedMultiCameraResponse,
  GetMultiCamerasParams,
  updateFloorParams,
  ApiUserWithIncludes,
  TagsRequest,
  GetLayoutsParams,
  AvailableLanguageResponse,
  ApiAuthentication,
  AvailableLanguageRequest,
  ApiAuthenticationCode,
  ApiUserSelfUpdate,
  PaginatedEventsResponse,
  PaginatedEventTypesResponse,
  EventsRequestParams,
  EventTypeRequestParams,
  EventFieldValues,
  PaginatedEventFieldValuesResponse,
  ApiUserUpdate,
  CameraAccessResponse,
  CameraAccessRequest,
  ResourceGrants,
  AuditLogAlertConditionRulesRequest,
  PaginatedAuditLogAlertConditionRules,
  AuditLogAlertConditionRule,
  CreateAuditLogAlertConditionRule,
  UpdateAuditLogAlertConditionRule,
  ApiAddUser,
  ApiPaginatedTrustedClientResponse,
  GetTrustedDevicesParams,
  ApiPaginatedAlertResponse,
  GetAlertsParams,
  AddNewLPRVehicleRecordInListRequestPayload,
  AddNewLPRVehicleRecordInListResponse,
  ApiPaginatedRuleResponse,
  CreateLPRAlertConditionRuleRequestPayload,
  CreateLPRAlertConditionRuleResponse,
  CreateLPRVehicleListRequestPayload,
  CreateLPRVehicleListResponse,
  GetRulesParams,
  LPRAcccountAlertsQueryParams,
  LPRAccountAlertsResponse,
  LPRAlertConditionRuleResponse,
  LPRAlertConditionRulesListFieldValuesResponse,
  LPRAlertConditionRulesListQueryParams,
  LPRAlertConditionRulesListResponse,
  LPRAlertResponse,
  LPRAlertsQueryParams,
  LPRAlertsResponse,
  LPREventQueryParams,
  LPREventResponse,
  LPREventsFieldValuesResponse,
  LPREventsQueryParams,
  LPREventsResponse,
  LPREventsSummaryQueryParams,
  LPREventsSummaryResponse,
  LPRVehicleListResponse,
  LPRVehicleListsFieldsResponse,
  LPRVehicleListsFieldValuesResponse,
  LPRVehicleListsQueryParams,
  LPRVehicleListsResponse,
  LPRVehicleRecordInListResponse,
  LPRVehicleRecordsInAllListsQueryParams,
  LPRVehicleRecordsInAllListsResponse,
  LPRVehicleRecordsInListQueryParams,
  LPRVehicleRecordsInListResponse,
  UpdateLPRAlertConditionRuleRequestPayload,
  UpdateLPRVehicleListRequestPayload,
  UpdateLPRVehicleRecordInListRequestPayload,
  GetFilesParams,
  ApiPaginatedFileResponse,
  TimeZonesList,
  TimeZonesRequest,
  ApiPaginatedActionResponse,
  ApiFileWithIncludes,
  UpdateFileParams,
  NewFileParams,
  ApiCreateExportResponse,
  ExportDetails,
  PaginatedJobResponse,
  ApiAlertListFieldResponse,
  GetAlertListFieldParams,
  GetJobsParams,
  ApiAuditLogListFieldResponse,
  CameraSettingsQueryParams,
  CameraSettingsResponse,
  UpdateDownloadParams,
  GetActionsParams,
  ApiActionCreate,
  ApiActionUpdate,
  AlertConditionRulesQueryParams,
  AlertConditionRulesResponse,
  AlertConditionRuleResponse,
  CreateAlertActionRuleRequestPayload,
  CreateAlertActionRuleResponse,
  AlertActionRulesQueryParams,
  AlertActionRulesResponse,
  AlertActionRuleResponse,
  UpdateAlertConditionRuleRequestPayload,
  UpdateAlertActionRuleRequestPayload,
  CreateAlertActionRequestPayload,
  CreateAlertActionResponse,
  AlertActionsQueryParams,
  AlertActionsResponse,
  AlertActionResponse,
  UpdateAlertActionRequestPayload,
  ApiRuleActionsCreate,
  ApiPaginatedRuleActionsResponse,
  ApiAccountPaginatedCredentials,
  ApiAccountCredentials,
  GetAccountCameraCredentialsParams,
  AddAccountCameraCredentialsParams,
  GetAccountsParams,
  SpeakerWithIncludes,
  GetActionRulesParams,
  GetMetricsParams,
  MetricQueryResponse,
  CameraTunnelResponse,
  CreateTunnelParam,
  ApiCopyExportBody,
  ApiCopyExportResponse,
  GetLocationParams,
  GetAvailableDevicesParams,
  SwapCameraParams,
  VSObjectClassResponse,
  VSObjectClassAttributesResponse,
  PatchBridgeSettings,
  GetBridgeSettings,
  GetBridgeParams,
  ApiSwitchAdd,
  SwitchPortActionParam,
  ApiSwitchUpdate,
  GetSwitchesParams,
  ApiSwitchWithIncludes,
  ApiBridgeWithIncludes,
  VSMapNLQueryToAttributesRequestPayload,
  VSMapNLQueryToAttributesQueryParams,
  VSMapNLQueryToAttributesResponse,
  VSEventsDeepSearchQueryParams,
  VSEventsDeepSearchRequestPayload,
  VSEventsDeepSearchResponse,
  VSEventQueryParams,
  VSEventResponse,
  VSEventsGroupSearchQueryParams,
  VSEventsGroupSearchRequestPayload,
  VSEventsGroupSearchResponse,
  VSEventsTimeGroupSearchQueryParams,
  VSEventsTimeGroupSearchRequestPayload,
  VSEventsTimeGroupSearchResponse,
  VSEventsListFieldValuesQueryParams,
  VSEventsListFieldValuesRequestPayload,
  VSEventsListFieldValuesResponse,
  VSEventsListObjectValuesQueryParams,
  ApiAuthSettings,
  ApiCameraWithIncludes,
  PatchCameraSettings,
  SpeakerSettingsQueryParams,
  AdvancedSpeakerSettings,
  VSEventsListObjectValuesResponse,
  GetMultiCameraParams,
  ApiMultiCameraWithIncludes,
  ApiPaginatedMultiCameraChannelResponse,
  ApiMultiCameraUpdate,
  MultiCameraSettingsQueryParams,
  MultiCameraSettingsGet,
  UpdateMultiCameraSettings,
  POSEventQueryParams,
  POSEventsResponse,
  POSEventsQueryParams,
  POSEventResponse,
  POSEventFieldValuesResponse,
  POSEventUpdateTransactionFlagPayload,
  ApiDewarpConfigComposite,
  ApiDewarpConfig
} from '../service/api-types';
import useCookie from './useCookie';
import { PtzSettings, PtzSettingsQueryParams } from './api-types/ptzSettings';
import { ApiGatewayCreate, ApiSensorGatewayMain } from './api-types/gateways';

type ApiListType = {
  token: string;
  baseURL: string;
  plainAuthToken: string;
}

class ApiList {

  headers() {
    return { Authorization: "bearer " + (this as unknown as ApiListType).token };
  }

  axiosConfig() {
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: this.headers(),
    };
  }

  axiosConfigForV1Api() {
    return {
      baseURL: "https://c000.eagleeyenetworks.com",
      withCredentials: true,
    };
  }

  axiosConfigForSpeaker() { // added temporarily, will be removed once ticket EEPD-12605 is resolved.
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: { Authorization: "Bearer " + (this as unknown as ApiListType).token },
    };
  }

  axiosConfigForMultipart() {
    const headers = Object.assign({}, this.headers(), {'Content-Type': 'multipart/form-data'});
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: headers,
    };
  }

  axiosConfigForBlob(): AxiosRequestConfig {
    return {
      baseURL: (this as unknown as ApiListType).baseURL,
      withCredentials: true,
      headers: this.headers(),
      responseType: 'blob',
    };
  }

  async setBaseUrl(apiServer: string) {
    try {
      const res = await axios.get(apiServer + '/clientSettings', this.axiosConfig());
      const url = `https://${res.data.httpsBaseUrl.hostname}/api/v3.0`;
      (this as unknown as ApiListType).baseURL = url;
      const { setCookie } = useCookie();
      setCookie('root_url', url, '0', '/');
      this.getMediaCookie();
    } catch (error) {
      console.log(error)
    }
  }
  
  async getMediaCookie() {
    const res = await axios.get('/media/session', this.axiosConfig());
    axios.get(res.data.url, this.axiosConfig());
  }

  async getCameras(params: GetCamerasParams): (Promise<ApiPaginatedCameraResponse | undefined>) {
    const { cameraId, ...newParams } = params;
    const config = Object.assign({}, this.axiosConfig(), { params: newParams });
    try {
      const res = await axios.get(`/cameras${cameraId ? "/" + cameraId : ""}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getCamera(cameraId: string, params?: GetCamerasParams): Promise<ApiCameraWithIncludes | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/cameras/${cameraId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async swapCamera(params: SwapCameraParams) {
    const { cameraId, guid} = params;
    try {
      const res = await axios.patch(`/cameras/${cameraId}:swap`, { guid }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCameras(params: GetMultiCamerasParams): (Promise<ApiPaginatedMultiCameraResponse | undefined>) {
    if (!params.include) {
      params.include = ['status','locationSummary','deviceAddress','timeZone','notes','tags','devicePosition','networkInfo','deviceInfo','firmware','visibleByBridges'].toString();
    }

    const config = Object.assign({}, this.axiosConfig(), { params });

    try {
      const res = await axios.get(`/multiCameras`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteCamera(cameraId: DeleteCameraId) {
    try {
      await axios.delete(`/cameras/${cameraId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async addCamera(payload: ApiBridgeCameraCreate): Promise<ApiCameraMain | undefined> {
    try {
      const res = await axios.post(`/cameras`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async editCamera(payload: any, id: any) {
    const res = await axios.patch(`/cameras/${id}`, payload, this.axiosConfig());
    return res.status;
  }

  async editCameraDevicePosition(payload: ApiDevicePositionCamera, id: string) {
    const res = await axios.patch(`/cameras/${id}/devicePosition`, payload, this.axiosConfig());
    return res.status;
  }

  async bulkUpdateCamera(payload: ApiUpdateBulkCamera): Promise<BulkUpdateResponses | undefined> {
    try {
      const res = await axios.post(`/cameras:bulkUpdate`, payload, this.axiosConfig());
      return res.data.response;
    } catch (error) {
      console.log(error);
    }
  }

  async getSpeakers(params: GetSpeakersParams): Promise<PaginatedSpeakerResponse | SpeakerWithIncludes | undefined> {

    const { speakerId, ...newParams } = params;

    if (!newParams.include) {
      newParams.include = ['deviceInfo', 'devicePosition', 'networkInfo', 'notes', 'settings', 'status', 'tags', 'timeZone', 'visibleByBridges', 'effectivePermissions'].toString();
    }

    const config = Object.assign({}, this.axiosConfigForSpeaker(), { params: newParams });

    try {
      const res = await axios.get(`/speakers${speakerId ? "/" + speakerId : ""}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteSpeaker(speakerId: DeleteSpeakerId) {
    try {
      await axios.delete(`/speakers/${speakerId}`, this.axiosConfigForSpeaker());
    } catch (error) {
      console.log(error);
    }
  }

  async addSpeaker(payload: ApiAddSpeaker): Promise<ApiSpeakerMain | undefined> {
    try {
      const res = await axios.post(`/speakers`, payload, this.axiosConfigForSpeaker());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async editSpeaker(payload:any, id:any) {
    try {
      const res = await axios.patch(`/speakers/${id}`, payload, this.axiosConfigForSpeaker());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getLayouts(payload: GetLayoutsParams): Promise<ApiPaginatedLayoutResponse | undefined> {
    try {
      const { layoutId, ...params } = payload;
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/layouts${layoutId ? "/" + layoutId : ""}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateLayout(params: UpdateLayoutParams) {
    const { layoutId, payload } = params;
    try {
      const res = await axios.patch(`/layouts/${layoutId}`, payload, this.axiosConfig());
      return res.status
    } catch (error) {
      console.log(error);
    }
  }

  async deleteLayouts(layoutId: DeleteLayoutId) {
    try {
      await axios.delete(`/layouts/${layoutId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async createLayout(newLayout: ApiLayoutCreate): Promise<ApiLayout | undefined> {
    try {
      const res = await axios.post(`/layouts`, newLayout, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getBridges(params: GetBridgeParams): Promise<ApiPaginatedBridgeResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/bridges`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getBridge(bridgeId: GetBridgeId, params?: GetBridgeParams): Promise<ApiBridgeWithIncludes | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/bridges/${bridgeId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getBridgeSettings(bridgeId: GetBridgeId): Promise<GetBridgeSettings | undefined> {
    try {
      const res = await axios.get(`/bridges/${bridgeId}/settings`, this.axiosConfig());
      return res.data.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchBridgeSettings(bridgeId: GetBridgeId, payload: PatchBridgeSettings) {
    try {
      const res = await axios.patch(`/bridges/${bridgeId}/settings`, { data: payload }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addBridge(bridge: ApiBridgeCreate): Promise<ApiBridgeMain | undefined> {
    try {
      const res = await axios.post(`/bridges`, bridge, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateBridge(params: UpdateBridgeParams) {
    const { bridgeId, bridge } = params;
    try {
      const res = await axios.patch(`/bridges/${bridgeId}`, bridge, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async swapBridge(params: SwapBridgeParams) {
    const { bridgeId, payload } = params;
    try {
      const res = await axios.patch(`/bridges/${bridgeId}:swap`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteBridge(bridgeId: DeleteBridgeId) {
    try {
      await axios.delete(`/bridges/${bridgeId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async getAvailableDevices(params: GetAvailableDevicesParams): Promise<ApiPaginatedAvailableDeviceResponse | undefined> {
    const config = Object.assign(this.axiosConfig(), { params})
    try {
      const res = await axios.get('/availableDevices', config);
      return res.data
    } catch (error) {
      console.log(error);
    }
  }

  async getSwitches(): Promise<ApiPaginatedSwitchResponse | undefined> {
    try {
      const res = await axios.get('/switches', this.axiosConfig());
      return res.data
    } catch (error) {
      console.log(error);
    }
  }

  async getSwitch(payload: GetSwitchesParams): Promise<ApiPaginatedSwitchResponse| ApiSwitchWithIncludes | undefined> {
    try {
      const { switchId, ...params } = payload;
      const config = Object.assign({}, this.axiosConfig(), {params});
      const res = await axios.get(`/switches${switchId ? "/" + switchId : ""}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateSwitch(switchId: string, payload: ApiSwitchUpdate): Promise<number | undefined> {
    try {
      const res = await axios.patch(`/switches/${switchId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async actionSwitchPort(payload: SwitchPortActionParam): Promise<number | undefined> {
    try {
      const { portId, switchId, action } = payload;
      const res = await axios.post(`/switches/${switchId}/ports/${portId}/actions`, {action}, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async addSwitchToBridge(switchId: string, param: ApiSwitchAdd): Promise<number | undefined> {
    try {
      const res = await axios.post(`/switches/${switchId}/connection`, param, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getFeeds(params: GetFeedsParams): Promise<ApiPaginatedFeedResponse | undefined> {
    try {
      if (!params.include) params.include = ['multipartUrl,flvUrl,webRtcUrl'].toString()

      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/feeds', config);
      return res.data
    } catch (error) {
      console.log(error);
    }
  }

  async getPTZPosition(cameraId: GetPTZPositionCameraId): Promise<ApiPtzPosition | undefined> {
    try {
      const res = await axios.get(`/cameras/${cameraId}/ptz/position`, this.axiosConfig());
      return res.data
    } catch (error) {
      console.log(error);
    }
  }

  async movePTZ(params: MovePTZParams) {
    const { cameraId, movementData } = params;
    try {
      await axios.put(`/cameras/${cameraId}/ptz/position`, movementData, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async getLocations(params: GetLocationParams, locationId?: string): Promise<PaginatedLocationResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/locations${locationId ? '/' + locationId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async addLocation(location: Location): Promise<BasicLocationResponse | undefined> {
    try {
      const res = await axios.post(`/locations`, location, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async editLocation(params: EditLocationParams) {
    const { locationId, location } = params;
    try {
      const res = await axios.patch(`/locations/${locationId}`, location, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteLocation(locationId: DeleteLocationId) {
    try {
      await axios.delete(`/locations/${locationId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async getLocation(locationId: GetLocationId): Promise<LocationGet | undefined> {
    try {
      const res = await axios.get(`/locations/${locationId}?include=notes,address,geometry,childLocationCount,effectivePermissions`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getNotifications(params: NotificationParams | undefined): Promise<Notifications | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/notifications', config);
      return res.data
    } catch (error) {
      console.log(error);
    }
  }

  async getNotificationActors(params: NotificationActorsParams | undefined): Promise<NotificationActors | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/notifications:actors', config);
      return res.data
    } catch (error) {
      console.log(error);
    }
  }

  async updateNotification(params: UpdateNotificationParams) {
    const { notificationId, payload } = params;
    try {
      const res = await axios.patch(`/notifications/${notificationId}`, payload, this.axiosConfig());
      return res.status
    } catch (error) {
      console.log(error);
    }
  }
  async getRecordedImage(params: RecordedImageParams, cTokenSource: CancelTokenSource): Promise<RecordedImage | undefined> {
    let data: ArrayBuffer | undefined = undefined;
    let errorMessage: string | undefined = undefined;
    let timestamp: string | undefined = undefined;
    try {
      const config: AxiosRequestConfig = {
        baseURL: (this as unknown as ApiListType).baseURL,
        withCredentials: true,
        responseType: 'arraybuffer',
        cancelToken: cTokenSource.token,
        headers: this.headers(),
        params
      };

      const res = await axios.get('/media/recordedImage.jpeg', config);
      if (res?.headers["x-een-timestamp"]) {
        timestamp = res.headers["x-een-timestamp"]
      }
      if (res?.data) {
        data = res.data;
      }
    } catch (error) {
      console.log(error);
      const recordedImageError = error as RecordedImageError;
      if(!recordedImageError?.response?.data) {
        errorMessage = undefined;
      }else{
        const errorDetails: RecordedImageErrorDetails = JSON.parse(arrayBufferToString(recordedImageError.response.data));
        errorMessage = errorDetails.message;
      }
    }
    return { data, errorMessage, timestamp };
  }

  async getLiveImage(deviceId: string): Promise<RecordedImage | undefined> {
    let data: ArrayBuffer | undefined = undefined;
    let errorMessage: string | undefined = undefined;
    let timestamp: string | undefined = undefined;
    try {
      const config = Object.assign({}, this.axiosConfig(), { params: { deviceId, type: "preview" } });
      const res = await axios.get('/media/liveImage.jpeg', config);
      if (res?.headers["x-een-timestamp"]) {
        timestamp = res.headers["x-een-timestamp"]
      }
      if (res?.data) {
        data = res.data;
      }
    } catch (error) {
      console.log(error);
      const recordedImageError = error as RecordedImageError;
      if(!recordedImageError?.response?.data) {
        errorMessage = undefined;
      }else{
        const errorDetails: RecordedImageErrorDetails = JSON.parse(arrayBufferToString(recordedImageError.response.data));
        errorMessage = errorDetails.message;
      }
    }
    return { data, errorMessage, timestamp };
  }

  async getMedia(params: mediaMainRequest): Promise<ApiPaginatedMediaResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/media', config);
      return res.data
    } catch (error) {
      console.log(error);
    }
  }

  async getFloors(locationId: GetLocationId): Promise<PaginatedFloorsResponse | undefined> {
    try {
      const res = await axios.get(`/locations/${locationId}/floors`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async addFloor(locationId: GetLocationId, payload: any): Promise<FloorResponse | undefined> {
    try {
      const res = await axios.post(`/locations/${locationId}/floors`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateFloor(locationId: GetLocationId, floorId: GetFloorId, payload: updateFloorParams) {
    try {
      const res = await axios.patch(`/locations/${locationId}/floors/${floorId}`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteFloor(locationId: GetLocationId, floorId: GetFloorId) {
    try {
      await axios.delete(`/locations/${locationId}/floors/${floorId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async getFloorplans(locationId: GetLocationId, floorId: GetFloorId): Promise<PaginatedFloorplansResponse | undefined> {
    try {
      const res = await axios.get(`/locations/${locationId}/floors/${floorId}/plans`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getFloorplan(locationId: GetLocationId, floorId: GetFloorId, type: string) {
    const res = await axios.get(`/locations/${locationId}/floors/${floorId}.${type}`, this.axiosConfigForBlob())
    return res && res.data
  }

  async addFloorplan(locationId: GetLocationId, floorId: GetFloorId, formData: FormData ): Promise<FloorplanResponse | undefined> {
    try {
      const res = await axios.post(`/locations/${locationId}/floors/${floorId}/plans`, formData, this.axiosConfigForMultipart());
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async getEditions(accountId?: EditionsAccountId): Promise<PaginatedEditionResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params: { accountId } });
      const res = await axios.get(`/editions`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getEdition(editionId: EditionId): Promise<Edition | undefined> {
    try {
      const res = await axios.get(`/editions/${editionId}`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAccountCapabilities(): Promise<ApiAccountCapabilities | undefined> {
    try {
      const res = await axios.get(`/accounts/self/capabilities`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAccount(params: GetAccountsParams): Promise<ApiAccountWithIncludes | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params })
      const res = await axios.get(`/accounts/self`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchAccount(userId: string, payload: ApiAccountPatch) {
    try {
      const res = await axios.patch(`/accounts/${userId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getAlerts(params?: GetAlertsParams, accountId?: string): Promise<ApiPaginatedAlertResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/${accountId ? 'accounts/' + accountId + '/' : ''}alerts`, config);
    return res.data;
  }

  async getAlertListFieldValues(params?: GetAlertListFieldParams): Promise<ApiAlertListFieldResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/alerts:listFieldValues`, config);
    return res.data;
  }

  async getAuditLogFieldValues(): Promise<ApiAuditLogListFieldResponse | undefined> {
    const res = await axios.get('/auditLogAlertConditionRules:createFieldValues', this.axiosConfig());
    return res.data
  }
  async getRules(params?: GetRulesParams): Promise<ApiPaginatedRuleResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/alertConditionRules`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getUsers(params: GetUsersParams, userId: string | undefined): Promise<ApiPaginatedUserResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/users${userId ? '/' + userId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getLanguages(params: AvailableLanguageRequest): Promise<AvailableLanguageResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/languages', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAuditLogs(params: AuditLogRequest | undefined): Promise<AuditEvents | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/auditLogs', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getAnalyticSnapshot(params: AnntRequest) {
    try {
      const plainAuthToken = (this as unknown as ApiListType).plainAuthToken;
      if(!plainAuthToken) {
        throw new Error('Auth token not found');
      }
      const config = Object.assign({}, this.axiosConfigForV1Api(), { params });
      const res = await axios.get('/g/analytics/snapshot?A='+plainAuthToken, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getTags(params: TagsRequest): Promise<TagsList | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/tags', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getUserSelf(): Promise<ApiUserWithIncludes | undefined> {
    try {
      const config = {
        ...this.axiosConfig(),
        params: {
          include: ['support'].toString()
        }
      }
      const res = await axios.get('/users/self', config);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  async passwordResetRequests(userId:string) {
    try {
      const res = await axios.post(`/users/${userId}/passwordResetRequests`, {}, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async patchUser(userId:string, payload: ApiUserSelfUpdate | ApiUserUpdate) {
    try {
      const res = await axios.patch(`/users/${userId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getTimeZones(params: TimeZonesRequest): Promise<TimeZonesList | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/timeZones', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateUserAuthentication(params: ApiAuthentication) {
    try {
      const res = await axios.patch(`/users/self/authentication`, { ...params }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getUserAuthentication() {
    try {
      const res = await axios.get(`/users/self/authentication`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async verifyAuthenticationCode(params: ApiAuthenticationCode) {
    try {
      const res = await axios.patch(`/users/self/authentication/code`, { ...params }, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getEvents(params: EventsRequestParams): Promise<PaginatedEventsResponse | undefined> {
    try {
      const config: AxiosRequestConfig = Object.assign(this.axiosConfig(), { params });
      if (params.type__in) {
        config.params.type__in = params.type__in.toString();
      }
      if (params.include) {
        config.params.include = params.include.toString();
      }
      const res = await axios.get('/events', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getEventTypes(params: EventTypeRequestParams): Promise<PaginatedEventTypesResponse | undefined> {
    const config = Object.assign(this.axiosConfig(), { params });
    try {
      const res = await axios.get('/eventTypes', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchEventFieldValues(deviceId: string): Promise<PaginatedEventFieldValuesResponse | undefined> {
    const res = await axios.get(`/events:listFieldValues?actor=camera:${deviceId}`, this.axiosConfig());
    return res.data;
  }

  async getResourceGrant(params: CameraAccessRequest): Promise<CameraAccessResponse | undefined> {
    try {
      const { userId, resourceType,...newParams } = params;
      const config = Object.assign({}, this.axiosConfig(), { params : newParams });
      const res = await axios.get(`resourceGrants?resourceType=${resourceType}&userId__in=${userId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async postResourceGrant(payload:ResourceGrants) {
    try {
      const res = await axios.post(`resourceGrants:bulkCreate`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteResourceGrant(payload:ResourceGrants) {
    try {
      const res = await axios.post(`resourceGrants:bulkDelete`, {'ids': payload}, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteUser(userId:string) {
    try {
      const res = await axios.delete(`/users/${userId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async postUser(payload: ApiAddUser) {
    try {
      const res = await axios.post(`/users`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getActions(params?: GetActionsParams): Promise<ApiPaginatedActionResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/alertActions${ params?.id ? '/' + params.id : ''}`, config);
    return res.data;
  }
  
  async postAction(payload: ApiActionCreate) {
    const res = await axios.post(`/alertActions`, payload, this.axiosConfig());
    return res.data;
  }
  
  async updateAction(actionId: string, payload: ApiActionUpdate) {
    const res = await axios.patch(`/alertActions/${actionId}`, payload, this.axiosConfig());
    return res.status;
  }

  async deleteAction(actionId: string) {
    const res = await axios.delete(`/alertActions/${actionId}`, this.axiosConfig());
    return res.data;
  }

  async getRuleActions(params?: GetActionRulesParams): Promise<ApiPaginatedRuleActionsResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/alertActionRules` , config);
    return res.data;
  }
  async postRuleActions(payload: ApiRuleActionsCreate) {
    const res = await axios.post('/alertActionRules', payload, this.axiosConfig());
    return res.data;
  }

  async updateRuleActions(ruleActionId: string, payload: ApiRuleActionsCreate) {
    const res = await axios.patch(`/alertActionRules/${ ruleActionId }`, payload, this.axiosConfig());
    return res.status;
  }
  async deleteRuleActions(ruleId: string) {
    const res = await axios.delete(`/alertActionRules/${ ruleId }`, this.axiosConfig());
    return res.data;
  }

  async getAuditLogAlertConditionRules(ruleId?: string, params?: AuditLogAlertConditionRulesRequest): Promise<PaginatedAuditLogAlertConditionRules | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get(`/auditLogAlertConditionRules${ ruleId ? '/' + ruleId : '' }`, config);
    return res.data;
  }

  async addAuditLogAlertConditionRule(payload: CreateAuditLogAlertConditionRule): Promise<AuditLogAlertConditionRule | undefined> {
    const res = await axios.post(`/auditLogAlertConditionRules`, payload, this.axiosConfig());
    return res.data;
  }

  async updateAuditLogAlertConditionRule(params: UpdateAuditLogAlertConditionRule) {
    const { ruleId, payload } = params;
    const res = await axios.patch(`/auditLogAlertConditionRules/${ ruleId }`, payload, this.axiosConfig());
    return res.status;
  }

  async deleteAuditLogAlertConditionRule(auditLogAlertConditionRuleId: string) {
    await axios.delete(`/auditLogAlertConditionRules/${ auditLogAlertConditionRuleId }`, this.axiosConfig());
  }

  async getTrustedDevices(params: GetTrustedDevicesParams): Promise<ApiPaginatedTrustedClientResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get('/users/self/trustedClients', config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteTrustedDevice(deviceId: string) {
    try {
      const res = await axios.delete(`/users/self/trustedClients/${deviceId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchCameraSettings(cameraId: string, params: CameraSettingsQueryParams): Promise<CameraSettingsResponse | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const response = await axios.get<CameraSettingsResponse>(`/cameras/${cameraId}/settings`, config);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }

  async patchCameraSettings(cameraId: string, payload: PatchCameraSettings): Promise<number | undefined> {
    try {
      const response = await axios.patch(`/cameras/${cameraId}/settings`, payload, this.axiosConfig());
      return response.status;
    } catch (error) {
      console.log(error)
    }
  }

  // To fetch image by passing image URL and it supports params as well
  
  async getImageByUrl(
    url: string,
    cTokenSource: CancelTokenSource,
    params?: RecordedImageParams
  ): Promise<RecordedImage | undefined> {
    let data: ArrayBuffer | undefined = undefined;
    let errorMessage: string | undefined = undefined;
    let timestamp: string | undefined = undefined;
    try {
      let config: AxiosRequestConfig = {
        withCredentials: true,
        responseType: 'arraybuffer',
        cancelToken: cTokenSource.token,
        headers: this.headers(),
      }

      if (params) config.params = params;

      const res = await axios.get(url, config);

      if (res?.data) {
        data = res.data;
      }
    } catch (error) {
      const recordedImageError = error as RecordedImageError;

      if (!recordedImageError?.response.data) {
        errorMessage = undefined;
      } else {
        const errorDetails: RecordedImageErrorDetails = JSON.parse(
          arrayBufferToString(recordedImageError.response.data)
        );

        errorMessage = errorDetails.message;
      }
    }

    return { data, errorMessage, timestamp };
  }

  /**
   * LPR APIs
   */

  // LPR Vehicle list APIs

  async fetchLPRVehicleLists(params?: LPRVehicleListsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRVehicleListsResponse>(
      '/lprVehicleLists',
      config
    );

    return res.data;
  }

  async createLPRVehicleList(payload: CreateLPRVehicleListRequestPayload) {
    const res = await axios.post<CreateLPRVehicleListResponse>(
      '/lprVehicleLists',
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRVehicleListsFields() {
    const res = await axios.get<LPRVehicleListsFieldsResponse>(
      '/lprVehicleLists:listFields',
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRVehicleListsFieldValues() {
    const res = await axios.get<LPRVehicleListsFieldValuesResponse>(
      '/lprVehicleLists:listFieldValues',
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRVehicleList(id: string) {
    const res = await axios.get<LPRVehicleListResponse>(
      `/lprVehicleLists/${id}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateLPRVehicleList(
    id: string,
    payload: UpdateLPRVehicleListRequestPayload
  ) {
    await axios.patch(`/lprVehicleLists/${id}`, payload, this.axiosConfig());
  }

  async deleteLPRVehicleList(id: string) {
    await axios.delete(`/lprVehicleLists/${id}`, this.axiosConfig());
  }

  async fetchLPRVehicleRecordsInList(
    id: string,
    params?: LPRVehicleRecordsInListQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRVehicleRecordsInListResponse>(
      `/lprVehicleLists/${id}/vehicles`,
      config
    );

    return res.data;
  }

  async addNewLPRVehicleRecordToList(
    id: string,
    payload: AddNewLPRVehicleRecordInListRequestPayload
  ) {
    const res = await axios.post<AddNewLPRVehicleRecordInListResponse>(
      `/lprVehicleLists/${id}/vehicles`,
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRVehicleRecordInList(id: string, recordID: string) {
    const res = await axios.get<LPRVehicleRecordInListResponse>(
      `/lprVehicleLists/${id}/vehicles/${recordID}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateLPRVehicleRecordInList({
    id,
    recordID,
    payload,
  }: {
    id: string;
    recordID: string;
    payload: UpdateLPRVehicleRecordInListRequestPayload;
  }) {
    await axios.patch(
      `/lprVehicleLists/${id}/vehicles/${recordID}`,
      payload,
      this.axiosConfig()
    );
  }

  async deleteLPRVehicleRecordInList(id: string, recordID: string) {
    await axios.delete(
      `/lprVehicleLists/${id}/vehicles/${recordID}`,
      this.axiosConfig()
    );
  }

  async searchLPRVehicleRecordsInList(
    params?: LPRVehicleRecordsInAllListsQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRVehicleRecordsInAllListsResponse>(
      '/lprVehicleLists:search',
      config
    );

    return res.data;
  }

  // LPR Rules APIs

  async createLPRAlertConditionRule(
    payload: CreateLPRAlertConditionRuleRequestPayload
  ) {
    const res = await axios.post<CreateLPRAlertConditionRuleResponse>(
      '/lprAlertConditionRules',
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRAlertConditionRules(
    params?: LPRAlertConditionRulesListQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRAlertConditionRulesListResponse>(
      '/lprAlertConditionRules',
      config
    );

    return res.data;
  }

  async fetchLPRAlertConditionRulesFieldValues() {
    const res = await axios.get<LPRAlertConditionRulesListFieldValuesResponse>(
      '/lprAlertConditionRules:listFieldValues',
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchLPRAlertConditionRule(id: string) {
    const res = await axios.get<LPRAlertConditionRuleResponse>(
      `/lprAlertConditionRules/${id}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateLPRAlertConditionRule(
    id: string,
    payload: UpdateLPRAlertConditionRuleRequestPayload
  ) {
    await axios.patch(
      `/lprAlertConditionRules/${id}`,
      payload,
      this.axiosConfig()
    );
  }

  async deleteLPRAlertConditionRule(id: string) {
    await axios.delete(`/lprAlertConditionRules/${id}`, this.axiosConfig());
  }

  // LPR Events APIs

  async fetchLPREvents(
    params?: LPREventsQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPREventsResponse>(
      '/lprEvents',
      config
    );

    return res.data;
  }

  async fetchLPREvent(
    id: string,
    params?: LPREventQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPREventResponse>(
      `/lprEvents/${id}`,
      config
    );

    return res.data;
  }

  async fetchLPREventsSummary(
    params?: LPREventsSummaryQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPREventsSummaryResponse>(
      '/lprEvents:summary',
      config
    );

    return res.data;
  }

  async fetchLPREventsFieldValues() {
    const res = await axios.get<LPREventsFieldValuesResponse>(
      '/lprEvents:listFieldValues',
      this.axiosConfig()
    );

    return res.data;
  }

  /**
   * Alerts APIs - prefixed with LPR inorder to avoid naming collisions with old alerts APIs
   */

  async fetchLPRAccountAlerts(
    id: string,
    params?: LPRAcccountAlertsQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRAccountAlertsResponse>(
      `/accounts/${id}/alerts`,
      config
    );

    return res.data;
  }

  async fetchLPRAlerts(params?: LPRAlertsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<LPRAlertsResponse>('/alerts', config);

    return res.data;
  }

  async fetchLPRAlert(id: string) {
    const res = await axios.get<LPRAlertResponse>(
      `/alerts/${id}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async getArchives(payload: GetFilesParams, resourceId?: string): Promise<ApiPaginatedFileResponse | ApiFileWithIncludes | undefined> {
    try {
      const { ...params } = payload;
      const config = Object.assign({}, this.axiosConfig(), { params });
      const res = await axios.get(`/files${resourceId? '/'+resourceId: ''}`,  config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteFile(fileId: string) {
    try {
      await axios.delete(`/files/${fileId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async updateFile(fileId: string, params: UpdateFileParams) {
    try {
      const res = await axios.patch(`/files/${fileId}`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async copyFile(fileId: string, params: UpdateFileParams) {
    try {
      const res = await axios.patch(`/files/${fileId}/copy`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getFileContent(fileId: string) {
    try {
      const res = await axios.get(`/files/${fileId}?alt=media`, this.axiosConfigForBlob());
      return res;
    } catch (error) {
      console.log(error);
    }
  }

  async createNewFile(params: NewFileParams) {
    try {
      const res = await axios.post(`/files`, params, this.axiosConfig());
      return res;
    } catch (error) {
      console.log(error);
    }
  }


  /**
   * Export api's
   */

  async postExport(payload: ExportDetails): Promise<ApiCreateExportResponse | undefined> {
    try {
      const res = await axios.post(`/exports`, payload, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchJobs(params: GetJobsParams, jobId?: string): Promise<PaginatedJobResponse | undefined> {
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/jobs${jobId ? '/'+jobId : ''}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteJob(jobId: string): Promise<void> {
    try {
      await axios.delete("/jobs/" + jobId, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async fetchDownloads(payload: GetFilesParams) {
    const { ...params } = payload;
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get("/downloads", config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDownload(fileId: string) {
    try {
      await axios.delete(`/downloads/${fileId}`, this.axiosConfig());
    } catch (error) {
      console.log(error);
    }
  }

  async updateDownload(fileId: string, params: UpdateDownloadParams) {
    try {
      const res = await axios.patch(`/downloads/${fileId}`, params, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Alert rules APIs
   */

  // Alert condition rules

  async fetchAlertConditionRules(
    params?: AlertConditionRulesQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<AlertConditionRulesResponse>(
      `/alertConditionRules`,
      config
    );

    return res.data;
  }

  async fetchAlertConditionRule(id: string) {
    const res = await axios.get<AlertConditionRuleResponse>(
      `/alertConditionRules/${id}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateAlertConditionRule(
    id: string,
    payload: UpdateAlertConditionRuleRequestPayload
  ) {
    await axios.patch(
      `/alertConditionRules/${id}`,
      payload,
      this.axiosConfig()
    );
  }

  // Alert action rules

  async createAlertActionRule(
    payload: CreateAlertActionRuleRequestPayload
  ) {
    const res = await axios.post<CreateAlertActionRuleResponse>(
      '/alertActionRules',
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchAlertActionRules(
    params?: AlertActionRulesQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<AlertActionRulesResponse>(
      `/alertActionRules`,
      config
    );

    return res.data;
  }

  async fetchAlertActionRule(id: string) {
    const res = await axios.get<AlertActionRuleResponse>(
      `/alertActionRules/${id}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateAlertActionRule(
    id: string,
    payload: UpdateAlertActionRuleRequestPayload
  ) {
    await axios.patch(
      `/alertActionRules/${id}`,
      payload,
      this.axiosConfig()
    );
  }  

  async deleteAlertActionRule(id: string) {
    await axios.delete(`/alertActionRules/${id}`, this.axiosConfig());
  }
  
  // Alert actions

  async createAlertAction(
    payload: CreateAlertActionRequestPayload
  ) {
    const res = await axios.post<CreateAlertActionResponse>(
      '/alertActions',
      payload,
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchAlertActions(
    params?: AlertActionsQueryParams
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<AlertActionsResponse>(
      `/alertActions`,
      config
    );

    return res.data;
  }

  async fetchAlertAction(id: string) {
    const res = await axios.get<AlertActionResponse>(
      `/alertActions/${id}`,
      this.axiosConfig()
    );

    return res.data;
  }

  async updateAlertAction(
    id: string,
    payload: UpdateAlertActionRequestPayload
  ) {
    await axios.patch(
      `/alertActions/${id}`,
      payload,
      this.axiosConfig()
    );
  }

  async deleteAlertAction(id: string) {
    await axios.delete(`/alertActions/${id}`, this.axiosConfig());
  }

  async fetchAccountCameraCredentials(id: string, params: GetAccountCameraCredentialsParams) {
   try {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<ApiAccountPaginatedCredentials>(
      `/accounts/${id}/credentials`, config
    );

      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async addAccountCameraCredentials(id: string, credential: AddAccountCameraCredentialsParams) {
    try {
      const res = await axios.post<ApiAccountPaginatedCredentials>(
        `/accounts/${id}/credentials`, credential, this.axiosConfig()
      );
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteAccountCameraCredentials(id: string, credentialId: string) {
    try {
      const res = await axios.delete(`/accounts/${id}/credentials/${credentialId}`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async reTryExport(jobId: string, param: ApiCopyExportBody): Promise<ApiCopyExportResponse | undefined> {
    try {
      const res = await axios.post<ApiCopyExportResponse>(
        `/exports/${jobId}:copy`, param, this.axiosConfig()
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async createDeviceTunnel(deviceId: string, type: 'multiCameras' | 'cameras' | 'speakers' | 'availableDevices', param?: CreateTunnelParam): Promise<CameraTunnelResponse | undefined>  {
    try {
      const res = await axios.put(`/${type}/${deviceId}/tunnel`, {...param}, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDeviceTunnel(deviceId: string, type: 'multiCameras' | 'cameras' | 'speakers' | 'availableDevices'): Promise<number | undefined> {
    try {
      const res = await axios.delete(`/${type}/${deviceId}/tunnel`, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async fetchDeviceMetrics(deviceId: string, api: "cameras" | "bridges", params: GetMetricsParams) {
    const queryParameters: Omit<GetMetricsParams, "target__in"> & {target__in: string | string[]} = params;
    queryParameters.target__in = params.target__in.toString();
    try {
      const config = Object.assign({}, this.axiosConfig(), { params: queryParameters });
      const res = await axios.get<MetricQueryResponse>(
        `/${api}/${deviceId}/metrics`, config
      );
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
  
  /**
   * Video search APIs
   */

  // Object class types

  async fetchVSObjectClasses() {
    const res = await axios.get<VSObjectClassResponse>(
      "/videoAnalyticEvents/objectClass",
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchVSObjectClassAttributes(objClass: string) {
    const res = await axios.get<VSObjectClassAttributesResponse>(
      `/videoAnalyticEvents/objectClass/${objClass}`,
      this.axiosConfig()
    );

    return res.data;
  }

  // Video analytics events

  async fetchVSAttributesForAnNLPQuery(
    params: VSMapNLQueryToAttributesQueryParams,
    payload: VSMapNLQueryToAttributesRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSMapNLQueryToAttributesResponse>(
      "/videoAnalyticEvents:parse",
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEventsByDeepSearch(
    params: VSEventsDeepSearchQueryParams,
    payload: VSEventsDeepSearchRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSEventsDeepSearchResponse>(
      "/videoAnalyticEvents:deepSearch",
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEvent(id: string, params: VSEventQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.get<VSEventResponse>(
      `/videoAnalyticEvents/${id}`,
      config
    );

    return res.data;
  }

  async fetchVSEventsByGroup(
    params: VSEventsGroupSearchQueryParams,
    payload: VSEventsGroupSearchRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSEventsGroupSearchResponse>(
      "/videoAnalyticEvents:deepSearchGroupByResource",
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEventsByTimeGroup(
    params: VSEventsTimeGroupSearchQueryParams,
    payload: VSEventsTimeGroupSearchRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSEventsTimeGroupSearchResponse>(
      "/videoAnalyticEvents:deepSearchGroupByTime",
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEventsFieldValues(
    params: VSEventsListFieldValuesQueryParams,
    payload: VSEventsListFieldValuesRequestPayload
  ) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.post<VSEventsListFieldValuesResponse>(
      "/videoAnalyticEvents:listFieldValues",
      payload,
      config
    );

    return res.data;
  }

  async fetchVSEventsObjectValues(params: VSEventsListObjectValuesQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });

    const res = await axios.get<VSEventsListObjectValuesResponse>(
      "/videoAnalyticEvents:listObjectValues",
      config
    );

    return res.data;
  }

   async getSSOAuthSettings(): Promise<ApiAuthSettings> {
    const res = await axios.get<ApiAuthSettings>(
      "/accounts/self/ssoAuthSettings",
      this.axiosConfig()
    );
    return res.data
   }

   async patchSSOAuthSettings(payload: ApiAuthSettings): Promise<ApiAuthSettings> {
    const res = await axios.patch<ApiAuthSettings>(
      "/accounts/self/ssoAuthSettings",
      payload,
      this.axiosConfig()
    );
    return res.data
   }

   async fetchSpeakerSettings(speakerId: string, params?: SpeakerSettingsQueryParams): Promise<AdvancedSpeakerSettings | undefined> {
    try {
      const config = Object.assign({}, this.axiosConfig(), { params });
      const response = await axios.get<AdvancedSpeakerSettings>(`/speakers/${speakerId}/settings`, config);
      return response.data;
    } catch (error) {
      console.log(error)
    }
  }

  async patchSpeakerSettings(speakerId: string, payload: AdvancedSpeakerSettings): Promise<number | undefined> {
    try {
      const response = await axios.patch(`/speakers/${speakerId}/settings`, payload, this.axiosConfig());
      return response.status;
    } catch (error) {
      console.log(error)
    }
  }

  async getMultiCamera(multiCameraId: string, params: GetMultiCameraParams): Promise<ApiMultiCameraWithIncludes | undefined>{
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/multiCameras/${multiCameraId}`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async patchMultiCamera(multiCameraId: string, payload: ApiMultiCameraUpdate): Promise<number | undefined>{
    try {
      const res = await axios.patch(`/multiCameras/${multiCameraId}`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCameraChannels(multiCameraId: string): Promise<ApiPaginatedMultiCameraChannelResponse | undefined>{
    const config = Object.assign({}, this.axiosConfig(), {});
    try {
      const res = await axios.get(`/multiCameras/${multiCameraId}/channels`, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async getMultiCameraSettings(multiCameraId: string, params: MultiCameraSettingsQueryParams): Promise<MultiCameraSettingsGet | undefined>{
    const config = Object.assign({}, this.axiosConfig(), { params });
    try {
      const res = await axios.get(`/multiCameras/${multiCameraId}/settings`, config);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateMultiCameraSettings(multiCameraId: string, payload: UpdateMultiCameraSettings): Promise<number | undefined>{
    try {
      const res = await axios.patch(`/multiCameras/${multiCameraId}/settings`, payload, this.axiosConfig());
      return res.status;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * POS APIs
   */

  // Transactions APIs

  async fetchPOSEvents(params?: POSEventsQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<POSEventsResponse>(
      '/posEvents',
      config
    );

    return res.data;
  }

  async fetchPOSEvent(id: string, params?:POSEventQueryParams) {
    const config = Object.assign({}, this.axiosConfig(), { params });
    const res = await axios.get<POSEventResponse>(
      `/posEvents/${id}`,
      config
    );

    return res.data;
  }

  async updatePOSEvent(
    id: string,
    payload: POSEventUpdateTransactionFlagPayload
  ) {
    await axios.patch(`/posEvents/${id}`, payload, this.axiosConfig());
  }

  async fetchPOSEventsFieldValues() {
    const res = await axios.get<POSEventFieldValuesResponse>(
      '/posEvents:listFieldValues',
      this.axiosConfig()
    );

    return res.data;
  }

  async fetchPtzSettings(params: PtzSettingsQueryParams) {
    const res = await axios.get<PtzSettings>(
      `/cameras/${params.cameraId}/ptz/settings`,
      this.axiosConfig()
    );
    return res.data;
  }
  
  async addSensorGateway(sensorGateway: ApiGatewayCreate): Promise<ApiSensorGatewayMain | undefined> {
    try {
      const res = await axios.post(`/sensorGateways`, sensorGateway, this.axiosConfig());
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * @description Retrieves the complete dewarp configuration, including a list of all composites and panes 
   * associated with it. In a format that can be directly used with the dewarp SDK.
   */
  async getDewarpConfig(cameraId: string) {
    const res = await axios.get<ApiDewarpConfig>(
      `/cameras/${cameraId}/dewarp/config`, 
      this.axiosConfig()
    );
    return res.data;
  }

  /**
   * @description Get individual composite object by it's uuid
   */
  async getComposite(cameraId: string, compositeId: string) {
    const res = await axios.get<ApiDewarpConfigComposite>(
      `/cameras/${cameraId}/dewarp/composites/${compositeId}`,
      this.axiosConfig()
    );
    return res.data;
  }
}

export default new ApiList();
